import React from 'react';

const Bard_Intro = () => {
  return (
    <div>
      <h1>Bard_Intro</h1>
      <p>This is the Bard_Intro component.</p>
    </div>
  );
};

export default Bard_Intro;
